export const footerExampleData = {
  menus: [
    { link: "/blog", text: "Blog" },
    { link: "/contact-us", text: "Contact us" },
    { link: "/join", text: "Designers Join us" },
    { link: "/forum", text: "Forum" },
    { link: "/testimonials", text: "Testimonials" },
    { link: "/terms-of-service", text: "Terms of services" },
    { link: "/knowledgebase", text: "Knowledgebase" },
    { link: "/reffer", text: "Refer a friend, get 30$" },
    { link: "/privacy-policy", text: "Privacy policy" },
    { link: "/about-us", text: "About us" },
    { link: "/affilates", text: "Affiliates" },
    { link: "/refund-policy", text: "Refund policy" }
  ],
  socials: [
    { type: "facebook", link: "" },
    { type: "pinterest", link: "" },
    { type: "twitter", link: "" },
    { type: "linkedin", link: "" },
    { type: "instagram", link: "" }
  ]
};
